import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, MessageCircle, PenLine } from "lucide-react";
import { SITE } from "@/constants/site";

export const FloatingCTA = () => (
  <>
    <div
      data-testid="mobile-cta-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-3 gap-2 border-t border-amber-200/60 bg-cream/90 backdrop-blur-xl px-3 pt-2.5 pb-[calc(0.75rem+env(safe-area-inset-bottom))]"
    >
      <a
        href={`tel:${SITE.phone1}`}
        data-testid="cta-bar-call"
        className="flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-brand-sky text-white text-sm font-bold shadow-lg"
      >
        <Phone className="h-4 w-4" /> Call
      </a>
      <a
        href={SITE.whatsappLink}
        target="_blank"
        rel="noreferrer"
        data-testid="cta-bar-whatsapp"
        className="flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-emerald-500 text-white text-sm font-bold shadow-lg"
      >
        <MessageCircle className="h-4 w-4" /> WhatsApp
      </a>
      <Link
        to="/admissions"
        data-testid="cta-bar-enquire"
        className="flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-brand-coral text-white text-sm font-bold shadow-lg"
      >
        <PenLine className="h-4 w-4" /> Enquire
      </Link>
    </div>

    <motion.a
      href={SITE.whatsappLink}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-desktop"
      aria-label="Chat on WhatsApp"
      className="hidden md:grid fixed bottom-8 right-8 z-50 h-16 w-16 place-items-center rounded-full bg-emerald-500 text-white shadow-[0_10px_30px_rgba(16,185,129,0.45)]"
      whileHover={{ scale: 1.12, rotate: 6 }}
      whileTap={{ scale: 0.95 }}
    >
      <MessageCircle className="h-7 w-7" />
    </motion.a>
  </>
);
